import * as React from 'react';

import { IconProps } from './types';

const ListFilterIcon = React.forwardRef<SVGSVGElement, IconProps>((props, forwardedRef) => (
  <svg
    stroke="currentColor"
    fill="none"
    strokeWidth="2"
    viewBox="0 0 24 24"
    strokeLinecap="round"
    strokeLinejoin="round"
    height="200px"
    width="200px"
    xmlns="http://www.w3.org/2000/svg"
    ref={forwardedRef}
    {...props}
  >
    <path d="M3 6h18"></path>
    <path d="M7 12h10"></path>
    <path d="M10 18h4"></path>
  </svg>
));

ListFilterIcon.displayName = 'ListFilterIcon';
export default ListFilterIcon;
